<template>
  <button
    v-if="amount > 0"
    class="bidButton backgroundColorSuccess"
    type="submit"
    @click="showModal"
  >
    Pay Invoice
  </button>
</template>

<script>
export default {
  name: 'PayInvoiceButton',
  props: [
    'invoice_id',
    'amount'
  ],
  data () {
    return {
    }
  },
  computed: {
    authenticated: function () {
      return this.$store.getters.isAuthenticated
    },
    customModalMessage: function () {
      if (this.getUrlParameter('pay_invoice')) {
        if (this.getUrlParameter('pay_invoice').length > 0) {
          let getData = JSON.parse(this.getUrlParameter('pay_invoice'))
          return getData.custom_modal_message
        }
      }
      return ''
    },
    showModalOnMount: function () {
      if (this.getUrlParameter('pay_invoice')) {
        if (this.getUrlParameter('pay_invoice').length > 0) {
          let getData = JSON.parse(this.getUrlParameter('pay_invoice'))
          return getData.show_modal
        }
      }
      return false
    }
  },
  mounted () {
    if (this.showModalOnMount) {
      this.showModal()
    }
  },
  methods: {
    showModal () {
      let payload = {
        component: 'PayInvoice',
        props: {
          invoice_id: this.invoice_id,
          amount: this.amount,
          custom_modal_message: this.customModalMessage
        }
      }
      this.$store.dispatch('showModal', payload)
    },
    getUrlParameter: function (name) {
       
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
      let results = regex.exec(location.search)
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    }
  }
}
</script>

<style scoped>
</style>
